import { useV2CreateConsumptionReportMutation } from "@generated";
import { normalizeConsumptionReport } from "../helpers";
import { BucketSize, ConsumptionReport } from "../types";

interface RunReportArgs {
  startDate: string;
  bucketSize: BucketSize;
}

interface UseConsumptionReportResult {
  runReport: (args: RunReportArgs) => void;
  report: ConsumptionReport;
  isLoading: boolean;
  isUninitialized: boolean;
  error: unknown;
}

const useConsumptionReport = (): UseConsumptionReportResult => {
  const [createReport, state] = useV2CreateConsumptionReportMutation();

  const runReport = ({ startDate, bucketSize }: RunReportArgs) => {
    createReport({ body: { bucket_size: bucketSize, start_date: startDate } });
  };

  return {
    runReport,
    report: normalizeConsumptionReport(state.data),
    isLoading: state.isLoading,
    isUninitialized: state.isUninitialized,
    error: state.error,
  };
};

export default useConsumptionReport;
